import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import InfiniteScroll from "../../Components/Functionality/InfiniteScrollList";
import Container from "../../Components/UI/Container";
import { useDebatesStatusStore, useUserStore } from "../../Context/store";
import { useWorkspaceStore } from "../../Context/store";
import {
  useDebateReadMutation,
  useGetPublicUserWiseDebatedList,
} from "../../Web-Hooks/Debate/use-debate";
import Posts from "../Posts/Posts";

const PublicDebated = () => {
  const location = useLocation();
  const { pathname } = location;
  const opponentId = pathname.slice(1).split("/")[1];
  const { user } = useUserStore();
  const { selectedWorkspace } = useWorkspaceStore();
  const QueryKey = [
    "public-debated-workspace",
    user?.userId,
    selectedWorkspace?.workSpaceId,
    opponentId,
  ];
  const {
    data,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  } = useGetPublicUserWiseDebatedList(
    user?.userId,
    selectedWorkspace?.workSpaceId,
    opponentId
  );
  const { mutateAsync: readStatus, isPending } = useDebateReadMutation();

  const { allForumStatus } = useDebatesStatusStore();

  const hasNewDebates =
    isLoading || isPending
      ? false
      : opponentId
      ? allForumStatus?.publicDebatedFeed?.userSections?.includes(opponentId)
      : allForumStatus?.publicDebatedFeed?.userSections?.length > 0;

  useEffect(() => {
    readStatus({
      userId: user?.userId,
      workspaceId: selectedWorkspace?.workSpaceId,
      sectionType: "publicDebated",
      opponentId: opponentId,
    });
  }, [readStatus, user?.userId, selectedWorkspace?.workSpaceId, opponentId]);

  const handleRefetch = async() => {
    readStatus({
      userId: user?.userId,
      workspaceId: selectedWorkspace?.workSpaceId,
      sectionType: "publicDebated",
      opponentId: opponentId,
    });
    const response = await refetch();
    return response;
  };

  return (
    <Container>
      {/* Title */}
      <InfiniteScroll
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        isLoading={isLoading}
        hasNewData={hasNewDebates}
        queryKey={QueryKey}
        refetch={handleRefetch}
      >
        <Posts
          apiType={pathname}
          user={user}
          isLoading={isLoading && !isFetchingNextPage}
          AllDebates={data?.pages?.flatMap((page) => page.debateList)} // Combine all pages
        />
      </InfiniteScroll>
    </Container>
  );
};

export default PublicDebated;
